import React, { useEffect, useState } from 'react';
import { Form, Button, Card } from 'antd';
import { useNavigate, useParams } from "react-router-dom";
import { MODULES } from './Permissions';
import PermissionModuleRow from './PermissionModuleRow';
import { api } from '../../utils/apiClient';

const ViewRoles = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    useEffect(() => {
        if (!id) return;
        const loadRole = async () => {
            try {
                const { data } = await api.get(`/roles/${id}`);
                const role = data?.data;
                const selected = role?.permissions?.map(p => p.name) || [];
                const allPermissions = MODULES.flatMap(m => m.permissions.map(p => p.value));
                form.setFieldsValue({
                    name: role?.name,
                    allPermissions: selected.length === allPermissions.length
                });
                setSelectedPermissions(selected);
            } catch (error) {
                console.error(error);
            }
        };
        loadRole();
    }, [id,form]);

    return (
        <Card
            title={
                <div style={{ fontSize: 16, fontWeight: 'bold' }}>
                    View Role:
                    <span className="bg-success-focus text-success-main px-24 py-4 rounded-pill fw-medium text-sm" style={{ marginLeft: 10 }}>
                        {form.getFieldValue("name")}
                    </span>
                </div>
            }
            className="mx-auto mt-3"
            variant="borderless"
        >
            <Form form={form} layout="vertical">
                <Card size="small" style={{ marginBottom: 24 }}>
                    {MODULES.map(module => (
                        <PermissionModuleRow
                            key={module.key}
                            module={module}
                            selectedPermissions={selectedPermissions}
                            // View-only: no click handlers
                            handleModuleSelectAll={() => { }}
                            handleIndividualPermissionChange={() => (e, p) => { }}
                        />
                    ))}
                </Card>

                <Button
                    onClick={() => navigate(-1)}
                    style={{ backgroundColor: '#fa8c16', color: '#fff' }}
                >
                    Back
                </Button>
            </Form>
        </Card>
    );
};

export default ViewRoles;
